import React from 'react';
import { DatePicker, Flex, Select } from 'antd';
import styled from 'styled-components';
import dayjs from 'dayjs';

import { Periods, TFilters } from '../services/interfaces';
import { formatExtended } from '../../../../../shared/contants/date';
const { RangePicker } = DatePicker;

type TFilter = {
    filters?: TFilters;
    setFilters: (filters) => void;
};
export const PeriodFilter: React.FC<TFilter> = props => {
    const { filters, setFilters } = props;

    const onSelect = date => {
        if (date) {
            setFilters({
                period: Periods.period,
                date_from: formatExtended(date[0]),
                date_to: formatExtended(date[1]),
            });
        }
    };

    return (
        <Flex gap={8}>
            <StyledSelect
                defaultValue={'За месяц'}
                value={props.filters.period}
                options={[
                    {
                        value: Periods.day,
                        label: 'За день',
                    },
                    {
                        value: Periods.week,
                        label: 'За неделю',
                    },
                    {
                        value: Periods.month,
                        label: 'За месяц',
                    },
                    {
                        value: Periods.year,
                        label: 'За год',
                    },
                    {
                        value: Periods.period,
                        label: 'За период',
                    },
                ]}
                onChange={value => setFilters({ period: value })}
            />
            {props.filters.period === 'period' && (
                <RangePicker
                    onChange={onSelect}
                    value={[
                        filters.date_from
                            ? dayjs(props.filters.date_from, 'DD.MM.YY')
                            : null,
                        filters.date_to
                            ? dayjs(props.filters.date_to, 'DD.MM.YY')
                            : null,
                    ]}
                    allowClear={false}
                    format='DD.MM.YY'
                />
            )}
        </Flex>
    );
};

const StyledSelect = styled(Select)`
    min-width: 115px;
`;
